import React from 'react';
import { DropDown } from './common';
import { connect } from 'react-redux';
import { DuLieuHeThong } from 'api';
import {validatable} from 'components/utils';

class DropDownChonLinhVucDonThu extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      loaiDonThuID: null,
      data: [],
      allData: []
    }
  }
  onChange(e) {
    this.props.onChange(e);
  }

  componentDidMount() {

  }

  loadData(loaiDonThuID) {
    let params = {
      cha: 'null',
      loaiDon: loaiDonThuID
    }
    DuLieuHeThong.actions.getLinhVucDonThu.request(params).then(res => {
      if (typeof res.data._embedded != "undefined") {
        // TODO: Use Redux

        this.setState({
          data: res.data._embedded.linhVucDonThus
        })
      }
    }).catch(err => {})
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.loaiDonThuID != nextProps.loaiDonThuID) {
      if (nextProps.loaiDonThuID) {
        this.loadData(nextProps.loaiDonThuID);
      } else {
        this.setState({
          data: []
        });
      }
    }
  }

  render() {
    return (
      <DropDown className={this.props.className+`${this.state.data.length == 0 && this.props.allowHidden ? ' hidden' : ''}`} selectedValue={this.props.selectedValue} label="Lĩnh vực" require={this.props.require} isValid={this.props.isValid} options={ this.state.data } keyName='linhVucDonThuId' valueName='ten' onChange={ this.onChange.bind(this) } placeholder={ this.props.placeholder } bindValidator={this} channel="formTaoDon" name={this.props.name}/>
    )
  }
}

DropDownChonLinhVucDonThu.defaultProps = {
  allowHidden: true,
  onChange: function() {
    console.log('Need to assign onChange method');
  },
  placeholder: {
    key: '',
    text: 'Chọn...',
    name: ''
  },
  className: "col-input"
}

let bindStateToProps = state => {
  return {
  }
}

export default connect(bindStateToProps)(validatable(DropDownChonLinhVucDonThu));



// WEBPACK FOOTER //
// ./src/components/tt-forms/dropdown-chonlinhvucdonthu.jsx